import MenuItem from './MenuItem'
import MenuGroup from './MenuGroup'
import { menus } from '../const/menus'

/**
 * Under the current settings of the application and the way menus work (AdminDashboard),
 * linkTo could take 3 different properies:
 *  1. Number => takes a valid number associated with the pages its opening from dashboard
 *  2. undefined => clicking on this menu item wont trigger any action (stays on the same page)
 *  3. camelCase of the Page text => it opens the CommingSoon page !important
 */
/**
 * Sample Nested Menu Items in Menu Group in Full mode, it is rendered automatically using the Menus JSON
 * <MenuGroup text="Asset Management">
 *  <MenuItem level={0} text="Locations" image={Locations} linkTo={'23'}>
 *    <MenuItem level={1} text="Multi-Tenant Buildings" image={MultiTenantBuildings} linkTo={'multiTenantBuildings'} />
 *  </MenuItem>
 * </MenuGroup>
 */
const MenusFull = () => {
  return (
    <>
      {menus.map((group, index) => {
        return (
          <MenuGroup key={group.name} text={group.title}>
            {group.menus?.length &&
              group.menus.map((menuItem, index) => {
                return (
                  <MenuItem
                    key={`${group.name}_${menuItem.name}}`}
                    props={menuItem}
                  />
                )
              })}
          </MenuGroup>
        )
      })}
    </>
  )
}

export default MenusFull
